import React from 'react';

export function i18n(translations) {
	return (key, vars = null) => {
		let res = translations.hasOwnProperty(key) ? translations[key] : key;
		if (vars) {
			for (const tgtKey of Object.keys(vars)) {
				res = res.replace(`{{${tgtKey}}}`, vars[tgtKey]);
			}
		}
		return res;
	};
}

const TranslationContext = React.createContext({});
export const TranslationProvider = TranslationContext.Provider;
export default TranslationContext;
